import * as browser from "webextension-polyfill";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { FilterOrigin } from "../../filters/shared";
import { createFilterMetaData } from "~/utilities/background/bg-functions";
import { Prefs } from "~/alias/prefs";
import { initialize } from "~/alias/subscriptionInit";
const pausedKey = "paused";
const pausedFilterText1 = "@@*";
const pausedFilterText2 = "@@*$document";
const createDomainAllowlistRule = function (domain) {
    return `@@||${domain}^$document`;
};
const adblockIsPaused = async function (newValue) {
    if (newValue === undefined) {
        const response = await browser.storage.local.get(pausedKey);
        return response[pausedKey] === true;
    }
    if (newValue) {
        await browser.storage.local.set({ [pausedKey]: true });
        await ewe.filters.add([pausedFilterText1, pausedFilterText2]);
    }
    else {
        await ewe.filters.remove([pausedFilterText1, pausedFilterText2]);
        await browser.storage.local.remove(pausedKey);
    }
    return undefined;
};
const allowlistTab = async (tabURL, origin = FilterOrigin.popup) => {
    const autoExtendMs = Prefs.get("allowlisting_auto_extend_ms");
    const metadata = {
        ...createFilterMetaData(origin),
        expiresAt: Date.now() + autoExtendMs,
        autoExtendMs,
    };
    const url = new URL(tabURL);
    const host = url.hostname.replace(/^www\./, "");
    await ewe.filters.add(createDomainAllowlistRule(host), metadata);
};
const removeAllAllowlistRulesForTab = async (tabId) => {
    const filters = await ewe.filters.getAllowingFilters(tabId);
    await ewe.filters.remove(filters);
    return filters.length > 0;
};
const isTabTemporaryAllowlisted = async (tabId) => {
    const filters = await ewe.filters.getAllowingFilters(tabId);
    let metaDataMatch = false;
    for (let i = 0; i < filters.length && !metaDataMatch; i++) {
        const metadata = await ewe.filters.getMetadata(filters[i]);
        metaDataMatch = (metadata === null || metadata === void 0 ? void 0 : metadata.expiresByTabId) === tabId;
    }
    return metaDataMatch;
};
async function start() {
    const response = await browser.storage.local.get(pausedKey);
    if (response[pausedKey]) {
        await initialize.then();
        await ewe.filters.remove([pausedFilterText1, pausedFilterText2]);
        await browser.storage.local.remove(pausedKey);
    }
}
function handleExtensionStartup() {
    void start();
}
browser.runtime.onStartup.addListener(handleExtensionStartup);
export { allowlistTab, isTabTemporaryAllowlisted, removeAllAllowlistRulesForTab, adblockIsPaused, pausedFilterText1, pausedFilterText2, };
